import React from "react";
import { Route, Routes, Outlet } from "react-router-dom";
import config from "./config";

import Auth from "./Auth";
import SignIn from "./SignIn";
import Login from "./Login";
import Logout from "./Logout";

import Audits from "./Audits";
import GroupedAudits from "./Audit/GroupedAudits";
import Audit from "./Audit";
import AltAsset from "./AltAsset";
import AuditSubmission from "./Audit/Submission/AuditSubmission";
import AuditDetails from "./Audit/AuditDetails";
import AuditAsset from "./AuditAsset";
import AuditAssets from "./AuditAssets";
import AssetDetails from "./AuditAsset/AssetDetails";
import FixData from "./FixData";
import AssetSearch from "./AuditAssets/Search";
import Settings from "./Settings";
import Troubleshoot from "./Troubleshoot";
import ContactForm from "./ContactForm";
import ExportAudit from "./ExportAudit";

import DebugComponent from "./DebugComponent";

const paths = {
    auth: `/${config.paths.auth}`,
    signIn: `/${config.paths.signIn}`,
    login: `/${config.paths.login}`,
    logout: `/${config.paths.logout}`,
    audits: `${config.paths.audits}`,
    groupedAudits: `${config.paths.groupedAudits}`,
    settings: `${config.paths.settings}`,
    troubleshoot: `${config.paths.troubleshoot}`,
    contactForm: `${config.paths.contactForm}`,
    auditAssets: `${config.paths.auditAssets}`,
    home: `/${config.paths.auth}/${config.paths.audits}`,
};

/**
 * App Routes Component
 */
export default () => {
    return (
        <Routes>
            <Route index element={<Login />} />
            <Route path={paths.auth} element={<Auth />}>
                <Route index element={<Audits />} />
                <Route path={paths.audits} element={<Outlet />}>
                    <Route index element={<Audits />} />
                    <Route path={"list"} element={<Audits />} />
                    {/* /auth/audits/1 */}
                    <Route path={":auditId"} element={<Audit />}>
                        <Route
                            path={"groupedAudits"}
                            element={<GroupedAudits />}
                        />
                        <Route path={"details"} element={<AuditDetails />} />
                        {/* /auth/audits/1/assets */}
                        <Route path={"assets"} element={<Outlet />}>
                            <Route path={"list"} element={<AuditAssets />} />
                            <Route
                                path={"exclude-remaining"}
                                element={<AssetDetails assetMode="exclude" />}
                            />
                            {/* /auth/audits/1/assets/1 */}
                            <Route path={":assetId"} element={<AuditAsset />}>
                                <Route
                                    path={"details"}
                                    element={<AssetDetails />}
                                />
                                <Route
                                    path={"exclude"}
                                    element={
                                        <AssetDetails assetMode="exclude" />
                                    }
                                />
                            </Route>
                        </Route>
                        <Route path={"new-asset"} element={<AltAsset />} />
                        <Route path={"search"} element={<AssetSearch />} />
                        <Route
                            path={"submit"}
                            element={<AuditSubmission />}
                        ></Route>

                        {/* Disabling route for now */}
                        {/* <Route path={"FixData"} element={<FixData />} /> */}
                        <Route
                            path={"export-audit"}
                            element={<ExportAudit />}
                        />
                    </Route>
                </Route>
                {/* <Route path={"debug-page"} element={<DebugComponent />} /> */}
                <Route path={paths.auditAssets} element={<AuditAssets />} />
                <Route path={paths.settings} element={<Settings />} />
                <Route path={paths.troubleshoot} element={<Troubleshoot />} />
                <Route path={paths.contactForm} element={<ContactForm />} />
            </Route>
            <Route path={paths.login} element={<Login />} />
            <Route path={paths.signIn} element={<SignIn />} />
            <Route path={paths.logout} element={<Logout />} />
        </Routes>
    );
};

/*
TODO: is it possible to tidy up above nesting hell with v6?
*/
